import { render, staticRenderFns } from "./SKDataTableAction.vue?vue&type=template&id=15c42a2f&scoped=true&"
import script from "./SKDataTableAction.vue?vue&type=script&lang=js&"
export * from "./SKDataTableAction.vue?vue&type=script&lang=js&"
import style0 from "./SKDataTableAction.vue?vue&type=style&index=0&id=15c42a2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c42a2f",
  null
  
)

export default component.exports